const sysytem = {
  state: {
    gutter: 20,
    bottomTab: 0, // 0-首页 1-学习 2-我的
    indexTab: 1, // // 1培训报名  2名师团队 3资讯中心  4精品课程
  },

  mutations: {
    UPDATE_BOTTOM_TAB: (state, data) => {
      state.bottomTab = data
    },
    UPDATE_INDEX_TAB: (state, data) => {
      state.indexTab = data
    },
  },

  actions: {
    upDateBottomTab: ({ commit },data) => { //底部框
      commit('UPDATE_BOTTOM_TAB', data)
    },
    upDateIndexTab: ({ commit },data) => { //首页tab
      commit('UPDATE_INDEX_TAB', data)
    },
  }
}

export default sysytem



// WEBPACK FOOTER //
// ./src/store/modules/sysytem.js